import { create } from 'zustand';

interface PlatformViewState {
  /** Set while a platform admin is "visiting" one organisation's pages read-only. */
  viewingOrgId: string | null;
  viewingOrgName: string | null;
  enterOrg: (id: string, name: string) => void;
  exitOrg: () => void;
}

/**
 * Deliberately NOT persisted (unlike authStore) — visiting an organisation
 * ends on refresh/new tab, which is the right default for a read-only peek
 * rather than something that should survive a session restore.
 */
export const usePlatformViewStore = create<PlatformViewState>((set) => ({
  viewingOrgId: null,
  viewingOrgName: null,
  enterOrg: (id, name) => set({ viewingOrgId: id, viewingOrgName: name }),
  exitOrg: () => set({ viewingOrgId: null, viewingOrgName: null }),
}));
